module.exports = "<p>\n  Logging off....\n</p>\n"